import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import Footer from '../../common/Footer'
import { maduraiRameshwaramData } from './tourPackageData'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'

const MaduraiRameshwaram = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Madurai Rameshwaram Kanyakumari" />
            <CommonBreadcrumb items={["Madurai Rameshwaram Kanyakumari"]} />
            <DynamicTourSection {...maduraiRameshwaramData} />
            <Footer />
        </>
    )
}

export default MaduraiRameshwaram